import { render, staticRenderFns } from "./TenantsForm.vue?vue&type=template&id=e52d094a&scoped=true"
import script from "./TenantsForm.vue?vue&type=script&lang=js"
export * from "./TenantsForm.vue?vue&type=script&lang=js"
import style0 from "./TenantsForm.vue?vue&type=style&index=0&id=e52d094a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52d094a",
  null
  
)

export default component.exports